import * as React from "react";
import {none, option, Option} from "ts-option";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {FocusableProps} from "../../common/props/FocusableProps";
import MailMultiSelector from "./MailMultiSelector";
import Email from "../../../model/email/Email";
import {InputActionMeta} from "react-select/lib/types";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {isEmail} from "../../../utils/ValidationUtils";

type Props = FormGroupProps<Email[]> & PlaceholderProps & FocusableProps & PlaceholderProps;

interface State {
	/**
	 * Text displayed when create mail and validation error
	 */
	promptText: string
	/**
	 * No result or non unique text
	 */
	noResultText: string
	/**
	 * Selector input value
	 */
	inputValue: string;
}

/**
 * Mail multi selector.
 */
export default class MailFormGroup extends React.PureComponent <Props, State> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onAdd = this.onAdd.bind(this);
		this.isUnique = this.isUnique.bind(this);
		this.state = {promptText: "Create email address:", noResultText: "", inputValue: ""}
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<MailMultiSelector items={none}
								   value={this.props.field.getOptionalValue()}
								   inputValue={this.state.inputValue}
								   onInputChange={this.onInputChange}
								   onChanged={this.onChange}
								   onAddOption={this.onAdd}
								   placeholder={"Add email address"}
								   clearable={false}
								   noResultsText={this.state.noResultText}
								   multi
								   promptTextCreator={(filterText) => `${this.state.promptText} ${filterText}`}
								   onInputKeyDown={() => {this.setState({promptText: "Create email address:"})}}
								   getNewOptionData={(value, label) => this.newOptionCreator(label)}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed emails list.
	 * @param data
	 */
	onChange(data: Option<Email[]>) {
		this.props.onChange(this.props.field.updateValue(data.isDefined && data.get.length > 0 ? data : none))
	}

	/**
	 * Selector input change callback.
	 * @param {string} inputValue
	 * @param {InputActionMeta} inputActionMeta
	 */
	onInputChange(inputValue: string, inputActionMeta: InputActionMeta) {
		if (inputActionMeta.action === 'input-change') {
			this.setState({inputValue});
		}
	}

	/**
	 * Callback on add new email.
	 * @param {string} newItem
	 */
	onAdd(newItem: string) {
		if (isEmail(newItem)) {
			if (this.isUnique(newItem, this.props.field.getOptionalValue().getOrElse([]))) {
				this.setState({inputValue: ""},
					() => this.props.onChange(this.props.field.updateValue(
						option(this.props.field.value.getOrElse([]).concat(this.newOptionCreator(newItem))))));
			}
			else {
				this.setState({promptText: "Email already exists: "});
			}
		}
		else {
			this.setState({promptText: "Email is not valid: "});
		}
	}

	newOptionCreator(newOption: string): Email {
		return new Email(newOption, true);
	}

	/**
	 * Check if option is unique
	 * @param {{option: Email; options: Email[]; labelKey: string; valueKey: string} arg
	 * @returns {boolean}
	 */
	isUnique(newItem: string, options: Email[]) {
		return !options.filter(i => i.value == newItem).length;
	}
}